import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import { AutoSizer } from 'react-virtualized';
import { MediaController } from 'media-chrome/react';
import ReactPlayer from 'react-player';
import { ControlBar } from './components';
export const VideoPlayer = ({ src, isLoading }) => {
    const playerRef = useRef(null);
    return (_jsx(Box, { w: '100%', position: 'relative', children: _jsx(AutoSizer, { disableHeight: true, children: ({ width }) => {
                const height = (width / 16) * 9;
                return (_jsx(Box, { w: `${width}px`, h: `${height}px`, children: isLoading ? (_jsx(Box, { position: 'absolute', bg: '{gradients.image_loading}', className: 'blinking', bottom: 0, right: 0, left: 0, top: 0 })) : (_jsxs(MediaController, { "data-tooltip-hidden": true, style: { width: '100%', aspectRatio: '16/9' }, children: [_jsx(ReactPlayer, { src: src, loop: true, slot: 'media', ref: playerRef, controls: false, style: { width: '100%', height: '100%' } }), _jsx(ControlBar, {})] })) }));
            } }) }));
};
//# sourceMappingURL=VideoPlayer.js.map